import React, { Component } from 'react';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';

class PublishRow extends Component {
  constructor(props){
      super(props);
      this.state = {
      }
  }

  render() {
    const {printHandler, printState, publishHandler, documentList, sys_doc_type_id, deleteHandler} = this.props;
    const CheckBox = props => {
        const checked = props.document && props.document.is_published === 1 ? "checked" : null;
        return <input {...props} checked={checked}/>
    };
    let document = null;
    if (documentList && documentList.length > 0){
      let index = documentList.findIndex(x => x.sys_doc_type_id === sys_doc_type_id); // master schedule
      if (index !== -1){
        document = documentList[index]
      }
    }
    return (
    <div className="pull-right">
      <div className="form-inline">
        <div className={document ? "form-group" : "form-group d-none"}>
          <label className="switch switch-lg">
            {document && document.document.perma_url ?
              <a href={document.document.perma_url} className="mr-10">Perma Link</a>
            : null}
            <CheckBox type="checkbox" document={document} onChange={() => publishHandler(document)}/>
            <span className="switch-indicator"></span>
            <span className="switch-description" style={{color:"#8b95a5"}}>Published</span>
          </label>
        </div>
        <div className="form-group btn-group">
          <a className={document ? "btn btn-sm btn-default btn-outline" : "btn btn-sm btn-default btn-outline d-none"} href={document ? document.document.document_url : "#"} target="_blank">View Current</a>
          <button className={document ? "btn btn-sm btn-default btn-outline" : "btn btn-sm btn-default btn-outline d-none"} onClick={() => deleteHandler(document)}>Delete Current</button>
          {printState ? <div style={{"verticalAlign":"right"}}><div className="spinner-circle-shadow pull-left"></div>Generating your document</div> : <button className={!document ? "btn btn-sm btn-default btn-outline" : "btn btn-sm btn-default btn-outline d-none"} onClick={printHandler}>Generate</button>}
        </div>
      </div>
    </div>);
  }
}



@inject('userStore')
@observer
class ModalDocuments extends Component {
    constructor(props){
        super(props);
        this.state = {
            master:false,
            participantList:false,
            participantSchedule:false,
            participantTotals:false,
            printingSchedule:false,
            printingProposal:false,
            printingContract:false,
            documentList:[],
            bus_document_list:[]
        }
        this.printSchedule = this.printSchedule.bind(this);
        this.printProposal = this.printProposal.bind(this);
        this.printContract = this.printContract.bind(this);
        this.publishDocument = this.publishDocument.bind(this);
        this.deleteDocument = this.deleteDocument.bind(this);
    }

    componentDidMount(){
      if (this.props.inquiry){
        post('/v2/get/booking_documents', {booking_hash_id: this.props.inquiry.hash_id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
              this.setState({
                documentList:res.data.document_list,
                bus_document_list:res.data.bus_document_list
              })
            } else {
              alert(this.data.message);
            }
        }).catch((error) => {
          alert(error);
          return error;
        });
        //
        // this.setState({
        //   documentList:this.props.inquiry.document_list
        // })//, () => {
          // try to find each of the document types
          // let index = this.state.documentList.findIndex(x => x.sys_doc_type_id === 2); // master schedule
          // if (index !== -1){
          //   this.setState({
          //     documentSchedule:this.state.documentList[index]
          //   })
          // }
          // index = this.state.documentList.findIndex(x => x.sys_doc_type_id === 1); // proposal
          // if (index !== -1){
          //   this.setState({
          //     documentProposal:this.state.documentList[index]
          //   })
          // }
          // index = this.state.documentList.findIndex(x => x.sys_doc_type_id === 4); // contract
          // if (index !== -1){
          //   this.setState({
          //     documentContract:this.state.documentList[index]
          //   })
          // }
        //})
      }
    }

    publishBusDocument = (document) => {
      if (document){
        post('/v2/document-publish', {booking_hash_id: this.props.inquiry.hash_id, bus_document_id: document.id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
              this.setState({
                documentList:res.data.document_list
              })
              alert(res.data.message);
            } else {
              alert(res.data.message);
            }
        }).catch((error) => {
          alert(error);
          return error;
        });
      }
    }

    publishDocument(document){
      if (document){
        post('/v2/post/publish_document', {hash_id: document.hash_id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
              let index = this.state.documentList.findIndex(x => x.hash_id === res.data.hash_id); // find updated document
              let tmpDoc = this.state.documentList[index];
              tmpDoc.is_published = res.data.is_published;
              this.setState({
                documentList:this.state.documentList
              })
              alert(res.data.message);
            } else {
              alert(res.data.message);
            }
        }).catch((error) => {
          alert(error);
          return error;
        });
      }
    }

    deleteDocument(document){
      if (document){
        post('/v2/post/delete_document', {hash_id: document.hash_id},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
              let index = this.state.documentList.findIndex(x => x.hash_id === res.data.hash_id); // find updated document
              let temp_documentList = Object.assign([], this.state.documentList);
              temp_documentList.splice(index, 1)
              if (index > -1){
                this.setState({
                  documentList:temp_documentList
                })
              }
            } else {
              alert(this.data.message);
            }
        }).catch((error) => {
          alert(error);
          return error;
        });
      }
    }


    printSchedule(){
        this.setState({
            printingSchedule:true
        }, ()=>{
            post('/v2/print/itinerary', {hash_id: this.props.inquiry.hash_id, showtotals: this.state.participantTotals, master: this.state.master, participants: this.state.participantSchedule, participant_list: this.state.participantList},{
                auth: {username: this.props.userStore.token}
            }).then((res) => {
                if (res.data.errors === 0){
                    // set interval to check status
                    var doc_id = res.data.id;
                    var notify = notify;
                    this.interval = setInterval(()=>{
                        post('/v2/print/is_generated', {id: doc_id},{
                          auth: {username: this.props.userStore.token}
                        }).then((res) => {
                            if (res.data.completed === 1){
                                // window.open(res.data.file);
                                let temp_documentList = Object.assign([], this.state.documentList);
                                temp_documentList.push(res.data.document);
                                clearInterval(this.interval);
                                this.setState({
                                  printingSchedule:false,
                                  documentList:temp_documentList
                                });
                            }
                        }).catch((error) => {
                          clearInterval(this.interval);
                          console.log(error);
                          this.setState({printingSchedule:false});
                          return error;
                        });
                    }, 3000);
                } else {
                    alert(this.data.message);
                    this.setState({printingSchedule:false});
                }
            }).catch((error) => {
                alert(error);
                this.setState({printingSchedule:false});
                return error;
            });
        });
    }

    printProposal(){
        this.setState({
            printingProposal:true
        }, ()=>{
            post('/v2/print/proposal', {hash_id: this.props.inquiry.hash_id},{
                auth: {username: this.props.userStore.token}
            }).then((res) => {
                if (res.data.errors === 0){
                    // set interval to check status
                    var doc_id = res.data.id;
                    var notify = notify;
                    this.interval = setInterval(()=>{
                        post('/v2/print/is_generated', {id: doc_id},{
                          auth: {username: this.props.userStore.token}
                        }).then((res) => {
                            if (res.data.completed === 1){
                                // window.open(res.data.file);
                                let temp_documentList = Object.assign([], this.state.documentList);
                                temp_documentList.push(res.data.document);
                                clearInterval(this.interval);
                                this.setState({
                                  printingProposal:false,
                                  documentList:temp_documentList
                                });
                            }
                        }).catch((error) => {
                            console.log(error);
                            clearInterval(this.interval);
                            this.setState({printingProposal:false});
                            return error;
                        });
                    }, 3000);
                } else {
                    console.log(this.data.message);
                    this.setState({printingProposal:false});
                }
            }).catch((error) => {
                console.log(error);
                this.setState({printingProposal:false});
                return error;
            });
        });
    }

    printContract(){
        this.setState({
            printingContract:true
        }, ()=>{
            post('/v2/print/contract', {hash_id: this.props.inquiry.hash_id},{
                auth: {username: this.props.userStore.token}
            }).then((res) => {
                if (res.data.errors === 0){
                    // set interval to check status
                    var doc_id = res.data.id;
                    var notify = notify;
                    this.interval = setInterval(()=>{
                        post('/v2/print/is_generated', {id: doc_id},{
                          auth: {username: this.props.userStore.token}
                        }).then((res) => {
                            if (res.data.completed === 1){
                                // window.open(res.data.file);
                                let temp_documentList = Object.assign([], this.state.documentList);
                                temp_documentList.push(res.data.document);
                                clearInterval(this.interval);
                                this.setState({
                                  printingContract:false,
                                  documentList:temp_documentList
                                });
                            }
                        }).catch((error) => {
                            console.log(error);
                            this.setState({printingContract:false});
                            return error;
                        });
                    }, 3000);
                } else {
                    console.log(this.data.message);
                    this.setState({printingContract:false});
                }
            }).catch((error) => {
                console.log(error);
                this.setState({printingContract:false});
                return error;
            });
        });
    }


    render() {
      if (!this.props.inquiry) return <div className="alert alert-danger">No Booking Loaded</div>;
      const CheckBox = props => {
        const checked = props.is_checked === 'true' ? "checked" : null;
        return <input {...props} checked={checked}/>
      };
      const CheckBox2 = props => {
        const checked = props.is_checked === true ? "checked" : null;
        return <input {...props} checked={checked}/>
      };
      const {bus_document_list, documentList} = this.state;
      return (
    	   <React.Fragment>
            {bus_document_list.length > 0 ?
             <div className="card card-bordered">
                 <div className="card-body">
                     <h3>Custom Documents</h3>
                     <p>These are documents uploaded in the Settings area.  You can make them available for viewing.</p>
                     {bus_document_list.map((bd, bd_index)=>
                       <React.Fragment key={bd_index}>
                       <label className="switch switch-lg">
                           <CheckBox2 type="checkbox" is_checked={documentList.findIndex(x => x.document_id === bd.document_id) !== -1} onChange={()=>{this.publishBusDocument(bd)}}/>
                           <span className="switch-indicator"></span>
                           <span className="switch-description">{bd.name} - {bd.description}</span>
                       </label><br/>
                       </React.Fragment>
                     )}
                 </div>
             </div>
            : null}
            <div className="card card-bordered">
                <div className="card-body">
                    <h3>Schedule</h3>
                    <p>The default schedule will display schedule broken down by artist.  You can customize the schedule by choosing options below.  To regenerate a document you must delete the document first.</p>
                    <label className="switch switch-lg">
                        <CheckBox type="checkbox" is_checked={this.state.master.toString()} onChange={() => {this.setState({master:!this.state.master});}}/>
                        <span className="switch-indicator"></span>
                        <span className="switch-description">Show Master Schedule - This is a complete list of all services and participants combined.</span>
                    </label><br/>
                    <label className="switch switch-lg">
                        <CheckBox type="checkbox" is_checked={this.state.participantList.toString()} onChange={() => {this.setState({participantList:!this.state.participantList});}}/>
                        <span className="switch-indicator"></span>
                        <span className="switch-description">Participant List - This is a breakdown of participants, their services, and service totals - this does not include a schedule.</span>
                    </label><br/>
                    <label className="switch switch-lg">
                        <CheckBox type="checkbox" is_checked={this.state.participantSchedule.toString()} onChange={() => {this.setState({participantSchedule:!this.state.participantSchedule});}}/>
                        <span className="switch-indicator"></span>
                        <span className="switch-description">Participant Schedule - This will break down participants and their service schedule.</span>
                    </label><br/>
                    <label className="switch switch-lg">
                        <CheckBox type="checkbox" is_checked={this.state.participantTotals.toString()} onChange={() => {this.setState({participantTotals:!this.state.participantTotals});}}/>
                        <span className="switch-indicator"></span>
                        <span className="switch-description">Service total in Participant Schedule - When above is selected, this will add service total to the participant section.</span>
                    </label>
                </div>
                <div className="card-footer">
                    <PublishRow printHandler={this.printSchedule} printState={this.state.printingSchedule} documentList={this.state.documentList} publishHandler={this.publishDocument} sys_doc_type_id={2} deleteHandler={this.deleteDocument}/>
                </div>
            </div>
            <div className="card card-bordered">
                <div className="card-body">
                    <h3>Proposal</h3>
                    <p>If you'd like to make the proposal available for your client you can generate and publish it here.  To regenerate a document you must delete the document first.</p>
                </div>
                <div className="card-footer">
                  <PublishRow printHandler={this.printProposal} printState={this.state.printingProposal} documentList={this.state.documentList} publishHandler={this.publishDocument} sys_doc_type_id={1} deleteHandler={this.deleteDocument}/>
                </div>
            </div>
            <div className="card card-bordered">
                <div className="card-body">
                    <h3>Contract</h3>
                    <p>Your client can print the contract when they are e-signing but you can also make the document available in their portal by generating and publishing here. To regenerate a document you must delete the document first.</p>
                </div>
                <div className="card-footer">
                  <PublishRow printHandler={this.printContract} printState={this.state.printingContract} documentList={this.state.documentList} publishHandler={this.publishDocument} sys_doc_type_id={4} deleteHandler={this.deleteDocument}/>
                </div>
            </div>
        </React.Fragment>
    )
  }
}

export default ModalDocuments;



// WEBPACK FOOTER //
// ./src/components/business/ModalDocuments.js